// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc } from '../../../queries/fragments.generated';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BillTermsTab_SaveBidContractRevisionMutationVariables = Types.Exact<{
  input: Types.SaveBidContractRevisionInput;
  entityId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type BillTermsTab_SaveBidContractRevisionMutation = { __typename?: 'Mutation', saveBidContractRevision: { __typename?: 'SaveBidContractRevisionResult', bidContractRevision: { __typename?: 'BidContractRevision', id: string, hasValidDrawTasks: boolean, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canAddDraws: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, draws: Array<{ __typename?: 'BidContractRevisionDraw', id: string, amountInBasisPoints: number, isDeposit: boolean, globalPlanTask?: { __typename?: 'GlobalPlanTask', nameForEntity: string, id: string, name: string } | null | undefined }> } } };

export type BillTermsTab_BasePlanGlobalPlanTasksQueryVariables = Types.Exact<{
  bidPackageId: Types.Scalars['ID']['input'];
  entityId: Types.Scalars['ID']['input'];
}>;


export type BillTermsTab_BasePlanGlobalPlanTasksQuery = { __typename?: 'Query', bidPackage: { __typename?: 'BidPackage', id: string, basePlanGlobalPlanTasks: Array<{ __typename?: 'GlobalPlanTask', id: string, nameForEntity: string }> } };


export const BillTermsTab_SaveBidContractRevisionDocument = gql`
    mutation BillTermsTab_SaveBidContractRevision($input: SaveBidContractRevisionInput!, $entityId: ID) {
  saveBidContractRevision(input: $input) {
    bidContractRevision {
      id
      canEdit {
        ...PotentialOperationDetails
      }
      canAddDraws {
        ...PotentialOperationDetails
      }
      hasValidDrawTasks
      draws {
        id
        amountInBasisPoints
        globalPlanTask {
          ...Named
          nameForEntity(entityId: $entityId)
        }
        isDeposit
      }
    }
  }
}
    ${PotentialOperationDetailsFragmentDoc}
${NamedFragmentDoc}`;
export type BillTermsTab_SaveBidContractRevisionMutationFn = Apollo.MutationFunction<BillTermsTab_SaveBidContractRevisionMutation, BillTermsTab_SaveBidContractRevisionMutationVariables>;

/**
 * __useBillTermsTab_SaveBidContractRevisionMutation__
 *
 * To run a mutation, you first call `useBillTermsTab_SaveBidContractRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillTermsTab_SaveBidContractRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billTermsTabSaveBidContractRevisionMutation, { data, loading, error }] = useBillTermsTab_SaveBidContractRevisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useBillTermsTab_SaveBidContractRevisionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BillTermsTab_SaveBidContractRevisionMutation, BillTermsTab_SaveBidContractRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BillTermsTab_SaveBidContractRevisionMutation, BillTermsTab_SaveBidContractRevisionMutationVariables>(BillTermsTab_SaveBidContractRevisionDocument, options);
      }
export type BillTermsTab_SaveBidContractRevisionMutationHookResult = ReturnType<typeof useBillTermsTab_SaveBidContractRevisionMutation>;
export type BillTermsTab_SaveBidContractRevisionMutationResult = Apollo.MutationResult<BillTermsTab_SaveBidContractRevisionMutation>;
export type BillTermsTab_SaveBidContractRevisionMutationOptions = Apollo.BaseMutationOptions<BillTermsTab_SaveBidContractRevisionMutation, BillTermsTab_SaveBidContractRevisionMutationVariables>;
export const BillTermsTab_BasePlanGlobalPlanTasksDocument = gql`
    query BillTermsTab_BasePlanGlobalPlanTasks($bidPackageId: ID!, $entityId: ID!) {
  bidPackage(id: $bidPackageId) {
    id
    basePlanGlobalPlanTasks {
      id
      nameForEntity(entityId: $entityId)
    }
  }
}
    `;

/**
 * __useBillTermsTab_BasePlanGlobalPlanTasksQuery__
 *
 * To run a query within a React component, call `useBillTermsTab_BasePlanGlobalPlanTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillTermsTab_BasePlanGlobalPlanTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillTermsTab_BasePlanGlobalPlanTasksQuery({
 *   variables: {
 *      bidPackageId: // value for 'bidPackageId'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useBillTermsTab_BasePlanGlobalPlanTasksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BillTermsTab_BasePlanGlobalPlanTasksQuery, BillTermsTab_BasePlanGlobalPlanTasksQueryVariables> & ({ variables: BillTermsTab_BasePlanGlobalPlanTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BillTermsTab_BasePlanGlobalPlanTasksQuery, BillTermsTab_BasePlanGlobalPlanTasksQueryVariables>(BillTermsTab_BasePlanGlobalPlanTasksDocument, options);
      }
export function useBillTermsTab_BasePlanGlobalPlanTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BillTermsTab_BasePlanGlobalPlanTasksQuery, BillTermsTab_BasePlanGlobalPlanTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BillTermsTab_BasePlanGlobalPlanTasksQuery, BillTermsTab_BasePlanGlobalPlanTasksQueryVariables>(BillTermsTab_BasePlanGlobalPlanTasksDocument, options);
        }
// @ts-ignore
export function useBillTermsTab_BasePlanGlobalPlanTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BillTermsTab_BasePlanGlobalPlanTasksQuery, BillTermsTab_BasePlanGlobalPlanTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BillTermsTab_BasePlanGlobalPlanTasksQuery, BillTermsTab_BasePlanGlobalPlanTasksQueryVariables>;
export function useBillTermsTab_BasePlanGlobalPlanTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillTermsTab_BasePlanGlobalPlanTasksQuery, BillTermsTab_BasePlanGlobalPlanTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BillTermsTab_BasePlanGlobalPlanTasksQuery | undefined, BillTermsTab_BasePlanGlobalPlanTasksQueryVariables>;
export function useBillTermsTab_BasePlanGlobalPlanTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillTermsTab_BasePlanGlobalPlanTasksQuery, BillTermsTab_BasePlanGlobalPlanTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BillTermsTab_BasePlanGlobalPlanTasksQuery, BillTermsTab_BasePlanGlobalPlanTasksQueryVariables>(BillTermsTab_BasePlanGlobalPlanTasksDocument, options);
        }
export type BillTermsTab_BasePlanGlobalPlanTasksQueryHookResult = ReturnType<typeof useBillTermsTab_BasePlanGlobalPlanTasksQuery>;
export type BillTermsTab_BasePlanGlobalPlanTasksLazyQueryHookResult = ReturnType<typeof useBillTermsTab_BasePlanGlobalPlanTasksLazyQuery>;
export type BillTermsTab_BasePlanGlobalPlanTasksSuspenseQueryHookResult = ReturnType<typeof useBillTermsTab_BasePlanGlobalPlanTasksSuspenseQuery>;
export type BillTermsTab_BasePlanGlobalPlanTasksQueryResult = Apollo.QueryResult<BillTermsTab_BasePlanGlobalPlanTasksQuery, BillTermsTab_BasePlanGlobalPlanTasksQueryVariables>;